module.exports = __webpack_public_path__ + "static/media/devpost.460b3aaf.svg";